module.exports = __webpack_public_path__ + "img/FBCircleIcon.aa7fef4d.svg";